import { z } from "zod";

export default {
  params: z.object({
    supervisorOrgId: z.string(),
    invitationId: z.string(),
  }),
  response: z.void(),
};
